import type { RouterProps } from 'contracts/Router';
import { Outlet, Navigate } from 'react-router-dom';
import {
  PendingStocksPage,
  StockBalancePage,
  LoadingOrdersPage,
  UnloadingOrdersPage,
} from 'pages/ScheduledReports';

const scheduledReports = ({ location, isLoggedIn }: RouterProps) => ({
  path: 'relatorios',
  element: isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: 'saldo-estoque',
      element: <StockBalancePage />,
    },
    {
      path: 'estoque-pendente-regularizacao',
      element: <PendingStocksPage />,
    },
    {
      path: 'solicitacoes-de-carregamento',
      element: <LoadingOrdersPage />,
    },
    {
      path: 'solicitacoes-de-descarregamento',
      element: <UnloadingOrdersPage />,
    },
  ],
});

export default scheduledReports;
